import { TextField, Autocomplete } from "@mui/material";
import type { SyntheticEvent } from "react";
import type { KeyValueOption, KeySelectChangedHandler } from "./types";

const facilityDamages: KeyValueOption[] = [
  { key: 1, value: "SS施設被害分類1" },
  { key: 2, value: "SS施設被害分類2" },
  { key: 3, value: "SS施設被害分類3" },
];

type FacilityDamageCategorySelectProps = {
  facilityDamageCategory?: number | string | null;
  changedValue: KeySelectChangedHandler;
};

export default function FacilityDamageCategorySelect({
  facilityDamageCategory,
  changedValue,
}: FacilityDamageCategorySelectProps) {
  const handleChange = (
    _event: SyntheticEvent,
    newValues: KeyValueOption | null,
  ) => {
    changedValue(newValues ? newValues.key : null);
  };

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={facilityDamages}
      getOptionLabel={(sale) => sale.value}
      isOptionEqualToValue={(option, value) => option.key === value.key}
      value={
        facilityDamages.find(
          (status) => status.key === facilityDamageCategory,
        ) || null
      }
      renderInput={(params) => (
        <TextField {...params} placeholder="SS施設被害分類選択" />
      )}
      onChange={handleChange}
    />
  );
}
